import { motion, useInView, useAnimation } from "framer-motion";
import { useRef, useEffect } from "react";

export default function RevealOnScroll(props) {
  const { children } = props;

  const ref = useRef(null);
  const isInview = useInView(ref, { once: true });
  const controls = useAnimation();

  useEffect(() => {
    if (isInview) {
      controls.start("visible");
    }
  }, [isInview]);

  return (
    <motion.div
      ref={ref}
      variants={{
        hidden: { opacity: 0, translateY: 30 },
        visible: { opacity: 1, translateY: 0 }
      }}
      transition={{
        type: "easeIn",
        duration: 0.5
      }}
      initial="hidden"
      animate={controls}
    >
      {children}
    </motion.div>
  );
}
